import React, { useEffect, useState } from 'react';
import { APIROOT } from '../../Helpers/configs';
import { filterMethod, filterMethodAll } from '../../Helpers/helpers';

import { matchSorter } from 'match-sorter';

import {
  Grid,
  TableContainer,
  Table,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  Autocomplete,
  TextField,
  Modal,
  Divider,
  Box,
  Typography,
  Button,
} from '@mui/material';

// const filterOptions = (options, state) => {
//   let newOptions = [];
//   options.forEach((element) => {
//     if (
//       element.place_name
//         .replace(',', '')
//         .toLowerCase()
//         .includes(state.inputValue.toLowerCase())
//     )
//       newOptions.push(element);
//   });
//   return newOptions;
// };

function StockUsed(props) {
  const rowsStockData = props.rowsStockData;
  const updateStockRow = props.updateStockRow;
  const removeStockRow = props.removeStockRow;

  const handleStock = (data) => {
    setOpenId(data.id);
    setStockItem(data);
    handleOpenStockModal();
  };

  const handleStockRemove = (data) => {
    removeStockRow(data);
  };

  const [stockItem, setStockItem] = useState({
    description: 'description',
    id: 1,
    qty: '1',
    code: 'enter stock code',
  });

  const [openId, setOpenId] = useState('');

  const [qty, setQty] = useState('1');

  const combineData = () => {
    let blob = {
      rowId: openId,
      id: stockItem.id,
      qty: qty,
      description: stockItem.description,
      code: stockItem.code,
    };
    return blob;
  };

  const [openStockModal, setOpenStockModal] = useState(false);
  const handleOpenStockModal = () => setOpenStockModal(true);
  const handleCloseStockModal = () => setOpenStockModal(false);

  // const [stockList, setStockList] = useState([]);
  const [stockCodes, setStockCodes] = useState([]);
  const [stockDescriptions, setStockDescriptions] = useState([]);

  const [stockDescriptionValue, setStockDescriptionValue] = useState({
    id: '404',
    name: 'select',
  });
  const [stockCodeValue, setStockDeCodeValue] = useState({
    id: '404',
    name: 'select',
  });

  async function mapStockCodes(stockList) {
    let stockCodes;
    stockCodes = stockList.map((obj) => ({
      id: obj.id,
      name: obj.code,
    }));
    let distinctCodes;
    try {
      let cab = 'name';
      distinctCodes = [
        ...new Map(distinctCodes.map((obj) => [obj[cab], obj])).values(),
      ];
    } catch (error) {
      distinctCodes = [...stockCodes];
    }

    setStockCodes(distinctCodes);
  }

  const filterOptions = filterMethodAll;

  async function mapStockDescriptions(stockList) {
    let stockCodes;
    stockCodes = stockList.map((obj) => ({
      id: obj.id,
      name: obj.description,
    }));
    let distinctCodes;
    try {
      let cab = 'name';
      distinctCodes = [
        ...new Map(distinctCodes.map((obj) => [obj[cab], obj])).values(),
      ];
    } catch (error) {
      distinctCodes = [...stockCodes];
    }

    setStockDescriptions(distinctCodes);
  }

  const handleListChange = (event, newValue) => {
    const eventTarget = event.target.parentNode.id.split('-').shift();
    let eventValue = newValue;
    // console.log(eventTarget, eventValue);
    setAutocompleteValue(eventTarget, eventValue);
  };

  const setAutocompleteValue = (event, newValue) => {
    switch (event) {
      case 'description':
        // setOpenCabType(newValue);
        setStockDescriptionValue(newValue);
        // setStockDeCodeValue({
        //   id: '404',
        //   name: 'select',
        // });
        setStockItem({ ...stockItem });
        break;
      case 'stockCode':
        setStockDeCodeValue(newValue);
        // setStockDescrptionValue({
        //   id: '404',
        //   name: 'select',
        // });
        setStockItem({ ...stockItem });
        break;
      default:
        break;
    }
    getStockItem(newValue);
  };

  const handleChange = (event) => {
    setQty(event.target.value);
  };

  const getStockItem = (item) => {
    let newObj = {};
    fullList.map((obj) => {
      if (obj.id === item.id) {
        newObj = { ...obj };
      } else {
      }
      setStockItem(newObj);
    });
  };

  const stockUpdate = () => {
    const DataBlob = { ...combineData() };
    updateStockRow(DataBlob, 'adjustStockItem');
    handleCloseStockModal();
  };

  const [fullList, setFullList] = useState([]);
  useEffect(() => {
    getStock('spares').then((data) => {
      setFullList(data.data.value);
      // setStockList(data.data.value);
      // mapStockCodes(data.data.value);
      // mapStockDescriptions(data.data.value);
    });
  }, []);

  return (
    <Grid item xs={12} md={12} style={{ textAlign: 'left' }}>
      <TableContainer>
        <Table
          sx={{ minWidth: 650, border: 1 }}
          size='small'
          aria-label='a dense table'
        >
          <TableHead>
            <TableRow>
              <TableCell
                id='stockCodeHead'
                key='stockCodeHead'
                name='stockCodeHead'
                sx={{ borderLeft: 1, borderBottom: 1, fontWeight: '700' }}
                align='left'
              >
                Stock Code
              </TableCell>
              <TableCell
                id='descriptionHead'
                key='descriptionHead'
                name='descriptionHead'
                sx={{ borderLeft: 1, borderBottom: 1, fontWeight: '700' }}
                width='25%'
                align='left'
              >
                Description
              </TableCell>
              <TableCell
                id='stockQtyHead'
                key='stockQtyHead'
                name='stockQtyHead'
                // onClick={handleClick}
                sx={{ borderLeft: 1, borderBottom: 1, fontWeight: '700' }}
                width='25%'
              >
                Qty
              </TableCell>
              <TableCell
                className='d-print-none'
                id='actionHead'
                key='actionHead'
                name='actionHead'
                sx={{ borderLeft: 1, borderBottom: 1, fontWeight: '700' }}
                width='10%'
                align='left'
              >
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody
            sx={{
              minHeight: '45px',
              height: '45px',
            }}
          >
            <TableRow
              sx={{
                display: rowsStockData.length > 0 && 'none',
                textAlign: 'center',
                '&:last-child td, &:last-child th': { borderBottom: 0 },
              }}
            >
              <TableCell>No Stock Used</TableCell>
            </TableRow>
            {rowsStockData.map((row) => (
              <TableRow
                key={row.id}
                name={row.id}
                id={row.id}
                sx={{
                  '&:last-child td, &:last-child th': { borderBottom: 0 },
                }}
              >
                <TableCell
                  onClick={() => handleStock(row)}
                  id='stockCode'
                  key='stockCode'
                  name='stockCode'
                  value={row.code}
                  // onBlurCapture={onBlurEventsCapture}
                  sx={{
                    borderLeft: 1,
                    borderBottom: 1,
                    background:
                      row.code === undefined ||
                      row.code === '' ||
                      row.code === null ||
                      row.code === 'select stock code'
                        ? '#00334433'
                        : 'none',
                  }}
                  // contentEditable
                  align='left'
                >
                  {row.code}
                </TableCell>
                <TableCell
                  onClick={() => handleStock(row)}
                  id='description'
                  key='description'
                  name='description'
                  value={row.description}
                  // onBlurCapture={onBlurEventsCapture}
                  // onClick={() => onBlurEventsCapture(row)}
                  sx={{
                    borderLeft: 1,
                    borderBottom: 1,
                    background:
                      row.code === undefined ||
                      row.code === '' ||
                      row.code === null ||
                      row.code === 'select stock code'
                        ? '#00334433'
                        : 'none',
                  }}
                  // contentEditable
                  align='left'
                >
                  {row.description}
                </TableCell>
                <TableCell
                  onClick={() => handleStock(row)}
                  id='stockQty'
                  key='stockQty'
                  name='stockQty'
                  value={row.qty}
                  // onBlurCapture={console.log(row)}
                  // onClick={() => onBlurEventsCapture(row)}
                  cabinetType
                  sx={{
                    borderLeft: 1,
                    borderBottom: 1,
                    background:
                      row.code === undefined ||
                      row.code === '' ||
                      row.code === null ||
                      row.code === 'select stock code'
                        ? '#00334433'
                        : 'none',
                  }}
                  // contentEditable
                  component='th'
                  scope='row'
                >
                  {row.qty}
                </TableCell>
                <TableCell
                  onClick={() => handleStockRemove(row.id)}
                  className='d-print-none'
                  // onClick={() => console.log(row)}
                  id='stockRemove'
                  key='stockRemove'
                  name='stockRemove'
                  value={row.qty}
                  // onBlurCapture={console.log(row)}
                  // onClick={() => onBlurEventsCapture(row)}
                  cabinetType
                  sx={{ borderLeft: 1, borderBottom: 1 }}
                  // contentEditable
                  component='th'
                  scope='row'
                >
                  <Button size='small'>Remove</Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Modal
        id='stockModal'
        open={openStockModal}
        onClose={handleCloseStockModal}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={style}>
          <form>
            <Grid
              container
              rowSpacing={0}
              columnSpacing={{ xs: 1, sm: 1, md: 1 }}
              rowGap={{ xs: 1, sm: 1, md: 1 }}
              style={{
                background: '#84a1bc91',
                padding: '5px 10px 5px 5px',
                borderRadius: '5px',
              }}
            >
              <Grid item xs={12} md={6}>
                <Typography variant='h6' sx={{ height: 40 }}>
                  Stock Item:
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Autocomplete
                  //filterOptions={filterMethodAll}
                  sx={{
                    width: '100%',
                    background: '#ffffff',
                    padding: 0,
                  }}
                  variant='standard'
                  size='small'
                  value={stockItem ?? null}
                  onChange={(event, newValue) => {
                    setStockItem((oldval) => {
                      return { ...oldval, ...newValue };
                    });
                  }}
                  disablePortal
                  options={fullList}
                  getOptionLabel={(option) =>
                    `${option.code} (${option.description})`
                  }
                  renderInput={(params) => <TextField {...params} />}
                  isOptionEqualToValue={(option, value) => {
                    return option.id === value.id ? true : false;
                  }}
                />
              </Grid>
              <Grid item xs={12} md={12} align='center'>
                <Typography variant='h5' sx={{ height: 40 }}>
                  Selected Item:
                </Typography>
              </Grid>
              <Grid item xs={6} md={6}>
                <Typography variant='h6' sx={{ height: 40 }}>
                  Qty:
                </Typography>
              </Grid>
              <Grid item xs={6} md={6}>
                <TextField
                  id='qty'
                  // type='number'
                  size='small'
                  fullWidth
                  defaultValue={stockItem.qty}
                  onChange={handleChange}
                ></TextField>
              </Grid>
              <Grid item xs={6} md={6}>
                <Typography variant='h6' sx={{ height: 40 }}>
                  Stock Code:
                </Typography>
              </Grid>
              <Grid item xs={6} md={6}>
                <TextField
                  inputProps={{ readOnly: true }}
                  value={stockItem.code}
                  id='stockCodeItem'
                  key='stockCodeItem'
                  name='stockCodeItem'
                  sx={{
                    width: '100%',
                    background: '#ffffff',
                    height: '40px',

                    padding: '5px 10px',
                    borderRadius: '5px',
                  }}
                  variant='standard'
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item xs={6} md={6}>
                <Typography variant='h6' sx={{ height: 40 }}>
                  Description:
                </Typography>
              </Grid>
              <Grid item xs={6} md={6}>
                <TextField
                  inputProps={{ readOnly: true }}
                  value={stockItem.description}
                  id='descriptionItem'
                  key='descriptionItem'
                  name='descriptionItem'
                  sx={{
                    width: '80%',
                    background: '#ffffff',
                    height: '40px',

                    padding: '5px 10px',
                    borderRadius: '5px',
                  }}
                  variant='standard'
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            </Grid>

            <Button
              sx={{ margin: '20px 0 0 0', float: 'right' }}
              variant='contained'
              type='submit'
              className='btn btn-primary'
              // onClick={handleFilterSubmit}
              // disabled={modalState === 'isSet' ? true : false}
              onClick={() => stockUpdate()}
            >
              Save
            </Button>
          </form>
        </Box>
      </Modal>
    </Grid>
  );
}

export default StockUsed;

//STOCK
async function getStock(type) {
  let JWT = localStorage.getItem('JWT_Key');
  let headers = {
    'content-type': 'application/JSON',
  };

  if (JWT) {
    headers['x-api-key'] = JWT;
  }

  let body = {
    pagereq: {
      filter: {
        fullfilter: [
          {
            field: 'type',
            search: type,
            strict: true,
          },
        ],
      },
    },
  };

  const request = new Request(`${APIROOT}/api/consumables`, {
    method: 'post',
    headers,
    body: JSON.stringify(body),
  });

  const response = await fetch(request);

  const data = response.json();
  return data;
}

//STYLE
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};
